export const loginType = {
  LOGIN_VIA_PASSWORD: 'loginViaPassword',
  LOGIN_VIA_SMS: 'loginViaSMS'
};
export const loginTypeOptions = [
  {
    name: loginType.LOGIN_VIA_PASSWORD,
    label: loginType.LOGIN_VIA_PASSWORD
  },
  {
    name: loginType.LOGIN_VIA_SMS,
    label: loginType.LOGIN_VIA_SMS
  }
];
